import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {ref, Ref} from 'vue';
import {BaseNodeType} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/_Base';

interface EditorPolyNodeCreateFormControllerClassOptions {
	node: BaseNodeType;
}

export class EditorPolyNodeCreateFormControllerClass {
	private static _instance: EditorPolyNodeCreateFormControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorPolyNodeCreateFormControllerClass());
	}

	private _nodeId: Ref<CoreGraphNodeId | null> = ref(null);
	private constructor() {}

	nodeId() {
		// console.log(this._nodeId.value);
		return this._nodeId.value;
	}

	//
	// methods
	//
	async show(options: EditorPolyNodeCreateFormControllerClassOptions) {
		this._nodeId.value = options.node.graphNodeId();
		console.log(this._nodeId.value);
	}
	close() {
		this._nodeId.value = null;
	}
}

export const EditorPolyNodeCreateFormController = EditorPolyNodeCreateFormControllerClass.instance();
